import React from "react";
import { Container } from "./styles";
import roadmapBg from "../../assets/images/RoadmapBg.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import TitleSection from "../TitleSection";

const RoadmapSlicker = () => {
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    // slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 810,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };
  const roadmapContents = {
    title: "Roadmap",
    phases: [
      {
        id: 0,
        title: "Phase 1",
        items: [
          "Idea generation",
          "Website and Socials development",
          "Establishment of community",
          "Marketing campaign",
          "Deploy smart contract",
          "Audit",
        ],
        active: true,
      },
      {
        id: 0,
        title: "Phase 2",
        items: [
          "Launch",
          "CoinMarketCap listing",
          "CoinGecko listing",
          "10 000 + Holders",
          "Staking with Referral link",
          "Utility upgrade",
        ],
        active: true,
      },
      {
        id: 0,
        title: "Phase 3",
        items: [
          "Calls and video calls release",
          "AMAs and new marketing campaigns",
          "CEX listing",
          "NFT Collections",
          "GameFi",
        ],
        active: true,
      },
    ],
  };
  return (
    <Container id="roadmap">
      <h2 className="dc-title">{roadmapContents.title}</h2>
      <Slider className="roadmap-line" {...settings}>
        {roadmapContents.phases.map((phase, index) => {
          return (
            <div key={`roadmap-step__${index}`} className="roadmap-line__step">
              <img src={roadmapBg} alt="" className="dc-background-img" />
              <h3 className="dc-title">{phase.title}</h3>
              <ul>
                {phase.items.map((item) => (
                  <li key={`rm-item__${item}`} className="dc-list">
                    <div className="dc-list__icon">
                      <span></span>
                    </div>
                    <p className="dc-text">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </Slider>
    </Container>
  );
};

export default RoadmapSlicker;
